<!--
  @Author: Yu Xiujie
  @Desc: 官网专题推广页
  @Date: 2022-07-26
-->

<template>
  <div class="extension-main">
    <!-- 轮播 -->
    <el-carousel trigger="click" height="720px" id="carouselExtension">
      <el-carousel-item v-for="item in bgExtensionList" :key="item.title">
        <div :style="{ 'background-image': 'url(' + item.bg + ')' }">
          <div @click="sendMsg">
            <img :src="item.src" alt="慧用工" />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 你的企业是否遇到过这些问题 -->
    <div class="centenImg" @click="sendMsg">
      <img
        class="centenImg_home_2"
        src="../../../static/pc/extensionPage/web_home_2.png"
        alt=""
      />
    </div>

    <!-- 慧用工 | 免费获取定制方案 -->
    <div id="extensionForm">
      <pc-form :source="source">
        <span class="title-txt pc-form-img">慧用工 | 免费获取定制方案</span>
      </pc-form>
    </div>

    <!-- 业务服务流程 -->
    <div class="centenImg" @click="sendMsg">
      <img
        class="centenImg_home_2"
        src="../../../static/pc/extensionPage/web_home_4.png"
        alt=""
      />
    </div>

    <!-- 业务服务流程 -->
    <div class="centenImg_home_outer " @click="sendMsg">
      <img
        class="centenImg_home_2"
        src="../../../static/pc/extensionPage/web_home_5.png"
        alt=""
      />
    </div>

    <!-- 合作伙伴 -->
    <div class="centenImg" @click="sendMsg">
      <img
        class="centenImg_home_2"
        src="../../../static/pc/extensionPage/web_home_6.png"
        alt=""
      />
    </div>

    <!-- 页面form -->
    <pc-form :source="source" class="marginTop88" id="anchor"
      ><span class="title-txt pc-form-img"
        >慧用工｜免费获取定制方案</span
      ></pc-form
    >

    <!-- 底部 -->
    <!-- <div class="posi-bottom">
      <div class="posi-bottom-sec1">
        <div class="bottom-foot-sec2">
          <span>联系我们</span>
          <span class="bottom-sec2-text"><img src="../../../static/pc/ic_home_phone.png"/>400-085-5500</span>
          <span class="bottom-sec2-text"><img src="../../../static/pc/ic_home_mail.png"/>market@hvyogo.com</span>
          <span class="bottom-sec2-text"><img src="../../../static/pc/ic_address.png"/>{{companyAddress}}</span>
        </div>

        <div class="bottom-foot-sec3">
          <img src="../../../static/pc/footer_img_wechat.png" alt="">
          <span>扫二维码 了解更多</span>
        </div>
      </div>
      
      <div class="bottom-foot-copy">
        <span>Copyright© {{timeYear}} {{whichCompName}} ｜
          <a href="https://beian.miit.gov.cn" target="_blank">{{icpText}}</a>
        </span>
      </div>
      
    </div> -->

    <!-- 弹窗form -->
    <pc-form-dialog :source="source">
      <span class="pc-form-text">慧用工｜免费获取定制方案</span>
      <!-- <span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span> -->
    </pc-form-dialog>

    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>
  </div>
</template>

<script>
import pcForm from "../../components/pcForm.vue";
import pcFormDialog from "../../components/pcFormDialog.vue";
import { BG_EXTENSION_LIST } from "../../service/businessConsts";
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  components: {
    "pc-form": pcForm,
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  data() {
    return {
      bgExtensionList: BG_EXTENSION_LIST,
      source: "",
      sourceF: "",
      bdVid: "",
      icpText: "",
      whichCompName: "",
      companyAddress: "",
      timeYear: ""
    };
  },

  created() {
    // JJFA_ZTTG
    this.timeYear = new Date().getFullYear();
    let compInfo = this.getSiteAddress();
    this.icpText = compInfo.whichIcp;
    this.whichCompName = compInfo.whichCompName;
    this.companyAddress = compInfo.companyAddress;

    // this.bdVid = this.$route.query.bd_vid;
    // source来源：：
    let hash = window.location.hash;
    this.source =
      hash.indexOf("source") > 0
        ? hash.substring(hash.indexOf("source")) + "&pageFrom=jjfa_zttg"
        : "&pageFrom=jjfa_zttg";
    this.sourceF = this.source + "_f";
  },

  methods: {
    // 兄弟传值
    sendMsg() {
      eventBus.$emit("pcOperaDiaLog", true);
    }
  }
};
</script>

<style lang="scss">
#carouselExtension {
  img {
    // width: 1%00;
    margin: 0 auto;
    height: 720px;
  }
}
#carouselExtension {
  .el-carousel__button {
    display: none;
  }
}

#carouselExtension .bannar_img img {
  display: none;
}

#carouselExtension .el-carousel__arrow {
  display: none;
}

#extensionForm {
  background: url("../../../static/pc/extensionPage/web_home_3.png") no-repeat
    top center;
  width: 100%;
  background-size: 100% 100%;
  background-size: cover;
  height: 650px;
  overflow: hidden;
}
#extensionForm .fullwidth-bg-img {
  display: none;
}

#extensionForm .pc-form-main {
  margin-bottom: 61px;
  background-size: 100% 100%;
}

#extensionForm .pc-form-main .pc-form {
  height: 528px;
  width: 860px;
  margin: 0 auto;
  margin-top: 61px;
  margin-bottom: 0px;
  display: block;
}
</style>

<style lang="scss" scoped>
.extension-main {
  padding: 0;
  margin: 0;
  width: 100%;
  overflow: hidden;

  .centenImg {
    width: 100%;
    background: #fbfdff;
    overflow: hidden;
  }

  .centenImg_home_2 {
    max-width: 1200px;
    margin: 0 auto;
    display: block;
    margin-bottom: 0;
    width: 100%;
  }

  .centenImg_home_outer {
    background: #171e2e;
  }

  // .posi-bottom{
  //   width: 100%;
  //   height: 275px;
  //   background: #100F0F;
  //   .posi-bottom-sec1{
  //     margin: 0 auto;
  //     width: 1200px;
  //     height: 215px;
  //     display: flex;
  //     justify-content: space-between;
  //     border-bottom: 1px solid #39424D;
  //   }

  //   .bottom-foot-sec2{
  //     // background: #fff;
  //     font-size: 16px;
  //     font-weight: 400;
  //     color: #78818C;
  //     span{
  //       display: block;
  //       text-align: left;
  //       margin-top: 19px;
  //       img{
  //         display: inline-block;
  //         width: 22px;
  //         height: 22px;
  //         margin-bottom: -6px;
  //         margin-right: 10px;
  //       }
  //     }
  //     span:nth-child(1){
  //       margin-top: 33px;
  //       font-weight: 400;
  //       color: #FFFFFF;
  //       font-size: 18px;
  //     }
  //   }

  //   .bottom-foot-sec3{
  //     img{
  //       width: 120px;
  //       display: block;
  //       margin-top: 31px;
  //       margin-bottom: 11px;
  //     }
  //     span{
  //       display: block;
  //       color: #FFFFFF;
  //     }
  //   }
  // }

  .bottom-foot-copy {
    margin: 0 auto;
    width: 1200px;
    font-size: 14px;
    color: #78818c;
    line-height: 60px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/extensionPage.vue